import * as types from 'actions/action-types';

var initialState = {
    logging: null,
    logging_saved: null,
    logging_pending: false,
    logging_save_pending: false,
    logging_unsubscribe: false,
};

const LoggingsReducer = (state = initialState, action) => {

    switch (action.type) {
        case types.LOGGING + '_PENDING': pending('logging'); break;
        case types.LOGGING + '_SAVE_PENDING': save_pending('logging'); break;
        case types.LOGGING + '_SAVE_FULFILLED': save_fulfilled('logging'); break;
        case types.LOGGING + '_FULFILLED': fulfilled('logging'); break;
        case types.LOGGING + '_CLEAR': clear('logging', {}); break;

        default: break;
    }

    return state;

    function pending(table) {
        state = {
            ...state,
            [table + '_pending']: true,
        };
    }
    function save_pending(table) {
        state = {
            ...state,
            [table + '_save_pending']: true,
        };
    }
    function save_fulfilled(table) {
        state = {
            ...state,
            [table + '_saved']: action.data,
            [table + '_save_pending']: false,
        };
    }
    function fulfilled(table) {
        state = {
            ...state,
            [table]: action.data,
            [table + '_pending']: false,
            [table + '_save_pending']: false,
            [table + '_unsubscribe']: (action.unsubscribe) ? action.unsubscribe : state[table + '_unsubscribe'],
        };
    }
    function clear(table, value) {
        state = {
            ...state,
            [table]: value,
        }
    }
}
export default LoggingsReducer;


